import queryString from 'qs';

const getHostListRequest = ({ queryParams }) => {
  const queries = { status: 'ACTIVE', 'role.id': [4] }; // active host and "Host" role

  if (queryParams?.brand) queries['brands.id'] = `[${queryParams.brand.value}]`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getHostListRequest;
